import React from "react";
import { PaziaButton } from "components/atoms/PaziaButton/PaziaButton";

interface SurveyPreviewNavigationButtonsProps {
  onBack?: () => void;
}
export const SurveyPreviewNavigationButtons = ({
  onBack,
}: SurveyPreviewNavigationButtonsProps) => {
  return (
    <div className="mt-4 flex w-full justify-between">
      {onBack ? (
        <PaziaButton
          btnType="button"
          type="tertiary"
          title="Cofnij"
          onClick={onBack}
        />
      ) : (
        <div></div>
      )}
      <PaziaButton type="tertiary" title="Następne" />
    </div>
  );
};
